$(document).on('click', '[formmethod]', function(event) {
  event.preventDefault()

  var form = $(this).closest('form')
  form.find('[name="_method"]').val($(this).attr('formmethod'))

  form.submit()
})
